import { render, staticRenderFns } from "./order_submit_again.vue?vue&type=template&id=6e152f07&scoped=true&"
import script from "./order_submit_again.vue?vue&type=script&lang=js&"
export * from "./order_submit_again.vue?vue&type=script&lang=js&"
import style0 from "./order_submit_again.vue?vue&type=style&index=0&id=6e152f07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e152f07",
  null
  
)

export default component.exports